export const PERMS = {
    READ: 'report_transport_invoicing.read',
}
